var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doRender)?_c('div',{staticClass:"view view_Benutzerverwaltung"},[(_vm.tabs.length > 1)?_c('viewTabsTop',{attrs:{"tabs":_vm.tabs}}):_vm._e(),(
    (_vm.currentTab.code === '' || _vm.currentTab.code === '000')
    && _vm.tabs.filter((o) => o.erlaubt === 'x|005|000').length > 0
  )?_c('Benutzer'):(
    _vm.currentTab.code === '010'
    && _vm.tabs.filter((o) => o.erlaubt === 'x|005|010').length > 0
  )?_c('Nutzerparameter'):(
    _vm.currentTab.code === '020'
    && _vm.tabs.filter((o) => o.erlaubt === 'x|005|020').length > 0
  )?_c('Nutzergruppen'):(
    _vm.currentTab.code === 'set'
    && _vm.tabs.filter((o) => o.erlaubt === 'x|005|set').length > 0
  )?_c('PasswortResetEinstellungen'):_c('p',[_vm._v(" Zugriff verweigert ")]),(_vm.tabs.length > 1)?_c('viewTabsBottom',{attrs:{"tabs":_vm.tabs}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }